/**
 * ExtractedDocumentDialog — focused popout for a single extracted document
 * (e.g. the proof-of-delivery substantiating an invoice line). Shows the
 * structured fields + line items pulled from the document, not the raw scan.
 *
 * Presentational: the caller supplies the data + open state.
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { T } from 'gt-react';
import {
  ExtractedDocumentTable,
  type ExtractedDocument,
} from './extracted-document';

export function ExtractedDocumentDialog({
  open,
  onOpenChange,
  doc,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  doc: ExtractedDocument;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[80vh] w-[92vw] max-w-2xl flex-col gap-0 p-0">
        <DialogHeader className="border-b px-4 py-3">
          <DialogTitle className="text-base">
            <T context="extracted document dialog title">Extracted document</T>
          </DialogTitle>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-hidden p-4">
          <ExtractedDocumentTable doc={doc} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
